import AdsRepository from './AdsRepository.js'

/**
 * @class
 * @implements AdsRepository
 */
export default class EmptyAdsRepository extends AdsRepository {
  getLastAdsSearchParams = () => Promise.resolve()

  getLastAdsSearches = () => Promise.resolve()

  saveLastAdsSearch = () => Promise.resolve()
}
